<template>
	<div id="table">
		<ul id="header">
			<li>Kit</li>
			<li>Kandža 1</li>
			<li>Kandža 2</li>
			<li>Kandža 3</li>
			<li>Kandža 4</p>
			<li>Guma 1</li>
			<li>Guma 2</li>
			<li>Guma 3</li>
			<li>Guma 4</li>
			<li>Uputstvo</li>
		</ul>

		<h1 id="alert" v-if="data.length === 0 && query.length !== 0">Nema rezultata pretrage.</h1>
		<ul class="row" v-for="kit in data" v-else>
			<li v-for="part in kit">
				<span v-if="!isLink(part)">{{ part }}</span>
				<span v-else><a :href="part" target="_blank">PDF</a></span>
			</li>
		</ul>
	</div>
</template>

<script>
export default {
	props: {
		data: Array,
		query: String
	},
	methods: {
		isLink(i) {
			if(i.startsWith('https')) {
				return true;
			} else {
				return false;
			}
		}
	}
}
</script>

<style scoped>
ul {
	list-style-type: none;
	padding: 0;
	overflow: hidden;
}
li {
	width: 108px;
	font-family: 'Lato', sans-serif;
	font-size: 16px;
	text-align: center;
	line-height: 50px;
}
li span {
	border-right: 0.5px solid #dfdede;
	display: block;
}
li a {
	color: rgb(66, 66, 66);
	background-color: #d2d2d2;
	font-weight: 700;
	display: block;
	//padding: 8px 30px;
	text-decoration: none;
	//border-radius: 100px;
	transition: all 0.2s ease-in-out;
}
li a:hover {
	background-color: #EA263D;
	color: white;
}
#table {
	margin-bottom: 70px;
}
#header {
	display: flex;
	width: 1080px;
	margin: 80px auto 10px auto;
	color: white;
	background-color: #444444;
	border-radius: 4px;
	border: 0.5px solid #2b2b2b;
	//text-transform: uppercase;
}
#header li {
	height: 50px;
}
.row {
	display: flex;
	flex-wrap: wrap;
	max-width: 1080px;
	margin: 4px auto;
	border: 0.5px solid #b0b0b0;
	background-color: white;
	min-height: 50px;
	line-height: 50px;
	border-radius: 6px;
}
.row li:first-child {
	font-weight: 700;
}
#alert {
	font-family: 'Lato', sans-serif;
	margin: 100px auto;
	text-align: center;
	color: #a3a3a3;
}
</style>



// WEBPACK FOOTER //
// src/Table.vue